const initialState = {
  loading: false,
  data: null,
  error: null,
};

const bannersReducers = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_BANNER_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_BANNER_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_BANNER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default bannersReducers;
